export default __webpack_public_path__ + "static/media/FC.ff4d9d83.svg";